import styled from 'styled-components'

export const WrapperContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  h2 {
    font-size: 14px;
    margin: 0;
    margin-top: 1.5rem;
  }
  @media only screen and (min-width: 1100px) {
    h2 {
      margin-bottom: 0.5rem;
    }
  }
  @media only screen and (min-width: 1400px) {
    h2 {
      margin-bottom: -3%;
    }
  }
`

export const Modal = styled.div`
  background: ${({ theme }) => `rgb(${theme.background.high})`};
  width: 60%;
  height: 30%;
  min-width: 300px;
  border-radius: 3px;
  border: solid 0.1px ${({ theme }) => `rgb(${theme.component.accent})`};

  hr {
    display: none;
    opacity: 0.3;
  }

  @media only screen and (min-width: 1090px) {
    width: 25%;
    height: 25%;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    hr {
      display: flex;
      width: 100%;
    }
  }
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  text-align: center;
  h2 {
    margin: 12px 0 0 0;
    font-weight: bold;
  }
`
export const WrapperButton = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1.5rem;
  text-align: center;

  button {
    border: none;
    background-color: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    font-size: 19px;
  }
`

export const Button = styled.div`
  display: flex;
  justify-content: end;
  border: none;
  button {
    border-radius: 5px;
    padding: 8px 8px 8px 8px;
    border: solid 0.1px ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    background-color: transparent;
    font-size: 14px;
  }
  .back-button {
    border-radius: 5px;
    background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
    color: ${({ theme }) => `rgb(${theme.background.high})`};
    border: none;
    padding: 8px 16px 8px 16px;
    font-weight: 600;
    font-size: 14px;
  }
`
